// JoinGame.js

import React, { useState } from 'react';
import GameContentProvider from '../providers/GameContentProvider';
import { useNavigate } from 'react-router-dom';
import "./JoinGame.css"
import { useDispatch } from 'react-redux';
import { loadGuestToken } from '../auth/authSlice';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const JoinGame = () => {
  const { t } = useTranslation(); // Initialize useTranslation

  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [timeout, setTimeout] = useState(false);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    // Accept only numeric input
    const numericValue = event.target.value.replace(/[^0-9]/g, '');
    setCode(numericValue);
  };

  const handleJoinGameClick = async () => {
    setError(null); // Reset error state before making a new request

    if (!code) {
      setError('Please enter a valid game code.'); // Show error for empty code
      return;
    }

    try {
      //Check if logged in as user or guest
      const gameContentProvider = new GameContentProvider();

      let token;
      token = localStorage.getItem('token');
      if (!token) {

        token = localStorage.getItem('guest_token');
        if (!token) {
          const newToken = await gameContentProvider.registerGuest();
          localStorage.setItem('guest_token', newToken.token);
          dispatch(loadGuestToken());
          token = newToken.token;
        }
      }


      const [data, status] = await gameContentProvider.checkCode(code, token);
      if (status === 429) {
        //Too many wrong reqeusts. Wait 1 min
        setTimeout(true);
        return;
      }

      if (data) {
        const currentDate = new Date();
        const startDate = new Date(data.start_date);
        const currentUtcDate = new Date(currentDate.getTime() + (currentDate.getTimezoneOffset() * 60000));

        if (currentUtcDate > startDate) {
          setError('The game has already started.');
        } else {
          // Code is valid, you can navigate or perform other actions here
          console.log('Code is valid!');
          console.log(data);

          navigate('/waiting_screen', { state: data });
        }
      } else {
        // Code is not valid, you can show an error message or take appropriate action
        setError('Invalid code. Please try again.');
      }
    } catch (error) {
      console.error('Error checking the code:', error);
      setError('An error occurred. Please try again later.');
    }
  };

  const handleCloseError = () => {
    setError(null);
    setTimeout(false);
  };

  return (
    <div className="join-container">
      <div className='background-image-start-game-teams'>
      <div className="center-container-start-game">
      <h2>{t('join_game')}</h2>
      <h3>{t('join_game_explanation')}</h3>
      <input
        type="number"
        min="0"
        placeholder={t('enter_game_code')}
        value={code}
        onChange={handleInputChange}
      />
      <button onClick={handleJoinGameClick}>{t('join_game')}</button>
    
      </div> </div>
      {/* Error Screen */}
      {error && (
        <div className="error-overlay">
          <div className="error-content">
            <h2>{t('error')}</h2>
            <p>{error}</p>
            <button onClick={handleCloseError}>{t('close')}</button>
          </div>
        </div>
      )}

      {/* Too many wrong reqeusts */}
      {timeout && (
        <div className="overlay">
          <div className="overlay-content">
            <h2>{t('too_many_wrong_requests')}</h2>
            <p>{t('please_try_again_in_1_minute')}</p>
            <br></br>
            <button onClick={handleCloseError}>{t('close')}</button>
          </div>
        </div>
      )}
   
    </div>
  );
};

export default JoinGame;
